import { useMemo } from 'react';
import {
  APPROVAL_READ_SCOPES,
  APPROVAL_WRITE_SCOPES,
  APPROVAL_APPROVE_SCOPES,
} from 'ui-product-approvals-common/constants/approvalScopes';
import type { ApprovalType } from 'ui-product-approvals-common';
import { useGetHasScope } from './useGetHasScope';

type ApprovalScopePermission = 'read' | 'write' | 'approve';

const SCOPES_BY_ACTION: Record<
  ApprovalScopePermission,
  Record<ApprovalType, string>
> = {
  read: APPROVAL_READ_SCOPES,
  write: APPROVAL_WRITE_SCOPES,
  approve: APPROVAL_APPROVE_SCOPES,
};

const getScopeName = (
  approvalType: ApprovalType | undefined,
  action: ApprovalScopePermission
): string | undefined => {
  if (approvalType === undefined) {
    return undefined;
  }
  return SCOPES_BY_ACTION[action][approvalType];
};

export const useHasApprovalScope = (
  approvalType: ApprovalType | undefined,
  action: ApprovalScopePermission
): boolean => {
  const hasScope = useGetHasScope();
  const scopeName = getScopeName(approvalType, action);
  return useMemo(
    () => (scopeName ? hasScope(scopeName) : false),
    [hasScope, scopeName]
  );
};
